module.exports = __webpack_public_path__ + "static/media/external_env_1_media_3.18916899.webp";